module.exports = __webpack_public_path__ + "static/img/comfortGelBlue.1fb4109.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/comfortGelBlue.png
// module id = Y7lX
// module chunks = 1